<template>
  <!-- MODAL Order Labels -->
  <div id="orderLabelsModal" class="col-12 justify-content-center pe-6" style="padding: 15vh 20%;">
    <div class="col-12 p-0 m-0 bg-caja section-container rounded-5">

      <div class="row overflow-hidden col-12 m-0 p-0 text-white bg-clomos rounded-top-5 pb-1 h-100">

        <div class="col-10" style="display: inherit">
          <h4 class="tx-left tx-clomos-white mb-2 ps-1 pt-2">
            <ion-icon name="arrow-redo-outline" class="tx-27 me-2 align-bottom"></ion-icon>
              Etiquetas
          </h4>
        </div>

        <div class="col-2 m-0 p-0" style="display: flex; justify-content: center;"
          @click="$emit('toggleOrderLabelsModal')">
          <ion-icon name="close" class="ms-auto tx-46 tx-white align-bottom"></ion-icon>
        </div>
      </div>

      <div class="form-group col-12 p-3">

        <div class="p-3 border-1" style="overflow: auto; max-height: 60vh;">

          <div class="modal-etiqueta" v-show="orderData.params != undefined && orderData.params.bultos[0]!=undefined">
            <div id ="etiquetasContainer" class="etiquetas-container">

              <!-- Mostrar los datos de la etiqueta -->
              <div v-for="(bulto, index) in orderData.params.bultos.length" :key="index" class="pb-3">
                <div class="etiqueta ms-auto me-auto">
                  <div class="d-flex justify-content-between align-items-start">
                    <div>
                      <div class="col-12">
                        <h1 class="mb-1 tx-left"><strong> 
                          Nº de Pedido: <br>{{ orderSummary.idPedido }}
                        </strong></h1>
                        <h3 class="tx-left pt-2">
                          Bulto {{ index + 1 }} de {{ orderData.params.bultos.length }}
                        </h3>
                      </div>
                    </div>
                    <div class="tx-right">
                      <vue-qr :text="generarTextoQR(pedido, index + 1, orderData.params.bultos.length)" :size="120"
                        class="qr"></vue-qr>
                    </div>
                  </div>
                  <div class="tx-left">
                    <div class="col">
                      <p class="mb-1">{{ orderSummary.nombre }} </p>
                      <p class="mb-1">{{ orderSummary.direccion }}</p>
                      <p class="mb-1">{{ orderSummary.codigoPostal }} {{ orderSummary.localidad }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

<!-- SUBMIT -->
            <div class="form-group col-lg-6 col-12 p-0 m-0 ms-auto me-auto">
              <div class="col-md-12">
                <button type="button" id="btnPrintLabels" class="btn btn-clomos w-100"
                @click="onPrintLabels">
                  <ion-icon name="print-outline" class="tx-22 me-2 align-bottom"></ion-icon>
                  {{dictionary['Imprimir'][session.user.language]}}
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
// import $ from 'jquery';
import vueQr from "vue-qr/src/packages/vue-qr.vue";

export default {
  name: "GenerarEtiquetas",
  components: { vueQr },
  props: {
    session: {
      type: Object,
      requiered: true,
    },
    dictionary: {
      type: Object,
      requiered: true,
    },
    countries: {
      type: Object,
      requiered: true,
    },
    timeZones: {
      type: Object,
      requiered: true,
    },
    currentCompany: {
      type: Object,
      requiered: true,
    },
    availableCompanies: {
      type: Object,
      requiered: true,
    },
    orderData: {
      type: Array,
      requiered: true,
    }
  },
  data() {
    return {
      orderSummary: null,
    }
  },
  emits: [ "toggleOrderLabelsModal" ],
  methods: {
    generarTextoQR(bulto, index) {
      // Construir la cadena para el código QR con la estructura especificada
      let cadenaQR = `${this.orderSummary.idPedido};${index};${this.orderData.params.bultos.length};${this.orderSummary.nombre};${this.orderSummary.direccion};${this.orderSummary.codigoPostal};${this.orderSummary.localidad}`;
      return cadenaQR;
    },
    onPrintLabels() {
        var mywindow = window.open('', 'PRINT', 'height=auto, width=auto');
        var labels = document.getElementById("etiquetasContainer").innerHTML;
        mywindow.document.write('</head><body >');
        mywindow.document.write(labels);
        mywindow.document.write('</body></html>');
        mywindow.document.close();
        mywindow.focus();
        mywindow.print();
        mywindow.close();
        mywindow.print();
    }
  },
  created() {
    this.orderSummary = JSON.parse(this.orderData.summary);
  }
};
</script>
  
<style scoped>
#orderLabelsModal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
}

.etiquetas-container {
  max-width: 47rem;
  margin: 0 auto;
}
.etiqueta {
  background-color: #fff;
  padding: 10px;
  border: 2px solid #000;
  border-radius: 10px;
  min-width: 650px;
  max-width: 650px;
  min-height: 260px;
  max-height: 260px;
  }
</style> 